export interface ISendySubscribe {
  name: string;
  email: string;
  language: string;
  appSumo: string;
}
